function handleErrors(response) {
    if (!response.ok) {
        return response.json().then(
            (data) => Promise.reject({"type": "HTTP", "status": response.status, "text": response.statusText, "data": data}),
            () => Promise.reject({"type": "HTTP2", "status": response.status, "text": response.statusText})
        )
    }
    return response;
}

function getCollection(file) {
    return fetch(file)
        .then(handleErrors)
        .then((response) => response.json());
}

function getItems(file) {
    return fetch(file)
        .then(handleErrors)
        .then((response) => response.json());
}

// function getFile(baseUrl, project, id) {
//     const url = new URL(`${project}/files/${id}`, baseUrl);
//     return fetch(url)
//         .then(handleErrors)
//         .then((response) => response.json());
// }

function postItem(baseUrl, project, collection, data) {
    const url = new URL(`${project}/items/${collection}`, baseUrl);
    const h = new Headers({
        "Content-Type": "application/json"
    })
    return fetch(url, { method: 'POST', headers: h, body: JSON.stringify(data) })
        .then(handleErrors)
        .then((response) => response.json());
}

function postFile(baseUrl, project, file) {
    const url = new URL(`${project}/files`, baseUrl);

    const formData  = new FormData();
    formData.append("data", file, file.name);
    return fetch(url, { method: 'POST', body: formData })
        .then(handleErrors)
        .then((response) => response.json());
}

// TODO: patchitem

export { getItems, /*getFile, */getCollection, postItem, postFile };
